import React from 'react'
import SettingCard from './component/settingCard'
import Assignment from '../../shared/assets/images/svg/assignment.svg'
import People from '../../shared/assets/images/svg/people_alt.svg'
import { useTranslation } from 'react-i18next'
import MyProfile from '../../shared/assets/images/svg/my_profile.svg'
import MyCompany from '../../shared/assets/images/svg/my_company.svg'
import Bookmark from '../../shared/assets/images/svg/bookmark.svg'
import Lock from '../../shared/assets/images/svg/lock_black.svg'
import Preferences from '../../shared/assets/images/svg/preferences.svg'
import Customers from '../../shared/assets/images/svg/mycustomers_dark.svg'




const SettingHome = () => {
    const{t}=useTranslation();
    return (
        <div className='settingHome'>
            <div className='container'>
                <h1 className='page-title'>{t('setting.my-setting')}</h1>
                <hr className='hr'/>
                <div className='row'>
                    <div className='col-lg-3 col-md-6'>
                        <SettingCard url="/company-info" icon={MyCompany} title={t('company-info.info')} info={t('setting.company-desc')}/>
                    </div>
                    <div className='col-lg-3 col-md-6'>
                        <SettingCard url="/my-profile" icon={MyProfile} title={t('my-profile.profile')} info={t('setting.profile-desc')} />
                    </div>
                    {/* <div className='col-lg-3 col-md-6'>
                        <SettingCard url="/my-profile" icon={Assignment} title="My Files" info="Services, activities, And billing data" />
                    </div> */}
                    {/* <div className='col-lg-3 col-md-6'>
                        <SettingCard url="/granted-users" icon={People} title="Granted Users" info="Username, Password, Support" />
                    </div> */}
                    <div className='col-lg-3 col-md-6'>
                        <SettingCard url="/change-password" icon={Lock} title={t('change-password.change')} info={t('setting.pass-desc')} />
                    </div>
                    <div className='col-lg-3 col-md-6'>
                        <SettingCard url="/preferences" icon={Preferences} title={t('prefrences.prefrence')} info={t('setting.pref-desc')} />
                    </div>
                    <div className='col-lg-3 col-md-6'>
                        <SettingCard url="/booking-users" icon={Bookmark} title={t('setting.booking-user')} info={t('setting.booking-user-desc')}/>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default SettingHome